export const CREATE_JOB_PALETTE = 'CREATE_JOB_PALETTE';
export const DELETE_COATING_OUT_JOB = 'DELETE_COATING_OUT_JOB';
export const CONFIRM_PALETTE = 'CONFIRM_PALETTE';
export const LOAD_COATING_OUT = 'LOAD_COATING_OUT';
export const LOAD_JOB_PALETTES_OUT = 'LOAD_JOB_PALETTES_OUT';
export const SET_CHECKED_JOB_RESULT_OUT = 'SET_CHECKED_JOB_RESULT_OUT';
export const SET_CHECKED_JOB_RESULT_RECORD_OUT = 'SET_CHECKED_JOB_RESULT_RECORD_OUT';
export const ADD_NEW_PALETTE_OUT = 'ADD_NEW_PALETTE_OUT';
export const PRINT_PALETTE_OUT = 'PRINT_PALETTE_OUT';
export const SHOW_ADD_NEW_PALETTE_POPUP_OUT = 'SHOW_ADD_NEW_PALETTE_POPUP_OUT';
export const HIDE_ADD_NEW_PALETTE_POPUP_OUT = 'HIDE_ADD_NEW_PALETTE_POPUP_OUT';
export const SET_IS_COATING_OUT_MODAL_VISIBLE = 'SET_IS_COATING_OUT_MODAL_VISIBLE';
export const SET_IS_TOTAL_QUANTITY_SELECTED = 'SET_IS_TOTAL_QUANTITY_SELECTED';
export const SET_COATINGOUT_FILTERS = 'SET_COATINGOUT_FILTERS';
export const RESET_COATING_OUT_FILTERS = 'RESET_COATING_OUT_FILTERS';
export const SET_JOB_PALETTES_OUT_FILTERS = 'SET_JOB_PALETTES_OUT_FILTERS';
export const RESET_JOB_PALETTES_OUT_FILTERS = 'RESET_JOB_PALETTES_OUT_FILTERS';
